import "../../scss/widgets/mobile-menu.scss";

;( function () {
    window.addEventListener("elementor/frontend/init", function () {
        elementorFrontend.hooks.addAction("frontend/element_ready/ikos-menu-list.default", function ($scope) {
            boom( $scope[0] )
        })
    })
}) ()

function boom( element ) {
    element.querySelectorAll('.pootle-mobile-menu-wrap').forEach( menu =>  {
        initMenu( menu )
    } )
}

function initMenu( wrap ) {

    const menu = wrap.querySelector('.pootle-mobile-menu');

    const header = menu.querySelector('.pootle-mobile-menu-header');
    const back = menu.querySelector('.pootle-mobile-menu-header button');
    const title = menu.querySelector('.pootle-mobile-menu-header .pootle-menu-title');
    const button = wrap.querySelector('.pootle-mobile-menu-button');
    const closeButton = wrap.querySelector('.pootle-menu-close');
    const popover = wrap.querySelector('.pootle-mobile-menu-popover');

    const history = [];

    const dropdowns = menu.querySelectorAll('.menu-item-has-children');
    const activeToken = "pootle-active-menu";


    button.addEventListener('click', function () {
        popover.classList.add("pootle-is-active");
    })

    closeButton.addEventListener('click', function () {
        popover.classList.remove("pootle-is-active");

        while ( history.length > 0 ) {
            updateHistory();
        }
    })

    function updateButtonTitle() {
        if ( history.length ) {
            header.classList.add( 'is-active' );
        } else {
            header.classList.remove( 'is-active' );
        }
    }

    function updateHistory( item = null, anchor = null ) {

        if ( item ) {
            item.classList.add( activeToken );
            history.push( { item, anchor} )
        } else if ( history.length ) {
            const current = history.pop();
            current.item.classList.remove( activeToken );
        }


        if ( history.length ) {
            title.innerHTML = history.at(-1).anchor.textContent;
            menu.classList.add('ikos-submenu-open');
        } else {
            title.innerHTML = '';
            menu.classList.remove('ikos-submenu-open');
        }

        history.forEach( ( _item, index ) => {
            const isLast = history.length - 1 === index;

            if ( isLast ) {
                _item.item.classList.add('is-showing')
            } else {
                _item.item.classList.remove('is-showing')
            }

        })

        updateButtonTitle();
    }

    dropdowns.forEach( dropdown => {
        const [ anchor, menu ] = dropdown.children;
        anchor.addEventListener("click", function ( event ) {
            event.preventDefault();
            updateHistory( menu, anchor )
        })

    } )

    back.addEventListener( "click", () => {
        updateHistory()
    } );

    menu.classList.add('mobile-menu-init');

}
